import router from './router'
import store from './store'
import { Message } from 'element-ui'
import {
    getToken,
    setAccessRoutes
} from '@/utils/auth'

const whiteList = ['/login','/login_admin', '/auth-redirect', '/bind', '/register','/twitter']

router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title
    } else {
        document.title = 'SDK管理平台'
    }
    if (to.matched.length === 0) {
        from.name ? next({
            name: from.name
        }) : next('/404');
    } else {
        next();
    }

    if (getToken()) {
        /* has token*/
        if (to.path === '/login') {
            next({
                path: '/'
            })
        } else {
            // console.log(store.state)
            if (store.state.roles.length === 0) {
                // 判断当前用户是否已拉取完user_info信息
                store.dispatch('GetInfo').then(res => {
                        // 拉取user_info
                        const roles = res.roles
                        store.dispatch('GenerateRoutes', {
                            roles
                        }).then(accessRoutes => {
                            // 根据roles权限生成可访问的路由表
                            // setAccessRoutes(accessRoutes) // cookie设置可访问路由表
                        })
                    })
                    .catch(err => {
                        if (err) Message.error(err)
                        store.dispatch('LogOut').then(() => {
                            next({
                                path: '/login'
                            })
                        })
                    })
            } else {
                next()
                    // 没有动态改变权限的需求可直接next() 删除下方权限判断 ↓
                    // if (hasPermission(store.getters.roles, to.meta.roles)) {
                    //   next()
                    // } else {
                    //   next({ path: '/401', replace: true, query: { noGoBack: true }})
                    // }
                    // 可删 ↑
            }
        }

    } else {
        // 没有token
        if (whiteList.indexOf(to.path) !== -1) {
            // 在免登录白名单，直接进入
            next()
        } else {
            next(`/login?redirect=${to.fullPath}`) // 否则全部重定向到登录页
                //   next()
        }
    }

})

router.afterEach(() => {})



// WEBPACK FOOTER //
// ./src/permission.js